import { NextPage } from 'next';
import { ReactElement, ReactNode } from 'react';
import { ApiError } from 'types';

// replace with isMpApiError
export function isApiError(error: any): error is ApiError {
  return error?.name === 'ApiError'
}

export type PartialRecord<K extends keyof any, T> = {
  [P in K]?: T;
};

export type NextPageWithLayout<P = Record<string, unknown>, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};
